module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "properties"
    }
  }, [_c('md-content', {
    staticClass: "full-height md-layout-row md-gutter md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('module-menu'), _c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [(!Object.keys(_vm.properties).length) ? _c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table-row', [_c('md-table-cell', {
    staticClass: "load"
  }, [_vm._v("В модуле не создано ни одного свойства")])], 1)], 1) : _vm._e(), (Object.keys(_vm.properties).length) ? _c('form', {
    staticClass: "md-scrollbar md-theme-default",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-card-content', _vm._l((_vm.properties), function(property) {
    return _c('module-property', {
      key: property.id,
      attrs: {
        "property": property
      }
    })
  }))], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ada9d0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Properties.vue
// module id = 1030
// module chunks = 0